import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Copy, Check } from 'lucide-react';
import { TRACKS } from '@/data/flow';

const Confetti = () => {
  const pieces = Array.from({ length: 16 });
  const colors = ['hsl(180 66% 34%)', 'hsl(158 60% 40%)', 'hsl(199 78% 50%)'];
  return (
    <div className="pointer-events-none absolute inset-x-0 top-0 h-40 overflow-hidden">
      {pieces.map((_, i) => (
        <motion.span
          key={i}
          initial={{ y: -20, x: `${(i / 16) * 100}%`, opacity: 0, rotate: 0 }}
          animate={{ y: 160, opacity: [0, 1, 1, 0], rotate: 360 }}
          transition={{ duration: 1.5 + (i % 4) * 0.25, delay: 0.1 + (i % 6) * 0.08, ease: 'easeIn' }}
          className="absolute h-2 w-2 rounded-sm"
          style={{ backgroundColor: colors[i % 3] }}
        />
      ))}
    </div>
  );
};

export const SuccessScreen = ({ record, answers, revised }) => {
  const [copied, setCopied] = useState(false);
  const trackLabel = TRACKS.find((t) => t.value === answers.track)?.label || '—';
  const firstName = (answers.fullName || '').split(' ')[0];

  useEffect(() => {
    if (!copied) return undefined;
    const t = setTimeout(() => setCopied(false), 1800);
    return () => clearTimeout(t);
  }, [copied]);

  const copyId = () => {
    navigator.clipboard?.writeText(record.id);
    setCopied(true);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="relative w-full overflow-hidden rounded-3xl border border-border bg-card shadow-elegant"
    >
      <Confetti />
      <div className="flex flex-col items-center p-8 text-center sm:p-12">
        <motion.div
          initial={{ scale: 0, rotate: -20 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ type: 'spring', stiffness: 200, damping: 14, delay: 0.1 }}
          className="grid h-20 w-20 place-items-center rounded-3xl bg-gradient-brand shadow-glow"
        >
          <CheckCircle2 className="h-10 w-10 text-primary-foreground" strokeWidth={2.2} />
        </motion.div>

        <h2 className="mt-6 font-display text-2xl font-bold text-foreground sm:text-3xl">
          {revised ? `Revisi tersimpan, ${firstName}!` : `Mantap, ${firstName}! Lamaranmu terkirim.`}
        </h2>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-muted-foreground sm:text-base">
          Kamu daftar untuk tim <span className="font-semibold text-foreground">{trackLabel}</span>. Tim rekrutmen Indilabs akan me-review profilmu dan mengabari lewat email & WhatsApp.
        </p>

        <button
          onClick={copyId}
          className="mt-6 inline-flex items-center gap-2 rounded-xl border border-primary/20 bg-primary-soft px-4 py-2.5 text-sm font-medium text-primary transition-colors hover:bg-primary/15"
        >
          <span className="text-muted-foreground">ID Lamaran:</span>
          <span className="font-display font-bold tracking-wide">{record.id}</span>
          {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
        </button>

        <p className="mt-6 text-xs text-muted-foreground">Simpan ID lamaranmu untuk referensi. Terima kasih sudah mendaftar di Indilabs!</p>
      </div>
    </motion.div>
  );
};
